import {MainVideoState} from "../definitions/MainVideoState";
import {frameChangeListeners} from "../state-change-side-effects/FrameChangeListeners";

export const runFrameChangedListeners = (state: MainVideoState) => {
    frameChangeListeners.forEach(l => l(state));
}
